"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementsAndStableIsotopesObject = void 0;
const elementsAndStableIsotopes_js_1 = require("./elementsAndStableIsotopes.js");
exports.elementsAndStableIsotopesObject = {};
for (const element of elementsAndStableIsotopes_js_1.elementsAndStableIsotopes) {
    exports.elementsAndStableIsotopesObject[element.symbol] = element;
}
//# sourceMappingURL=elementsAndStableIsotopesObject.js.map